var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.45 7.086l-4.95 4.95-4.95-4.95L4.136 8.5l4.95 4.95c.833.833 1.773.95 2.607.116.11-.04.184-.079.221-.116l4.95-4.95-1.414-1.414z","fill":"currentColor","fillRule":"nonzero"}));
}

ChevronInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
